import forage from 'localforage'
import { SSharedList } from '@/services/shared'
import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'

export const fCustomers = forage.createInstance({
  name: 'crms-customers',
  storeName: 'informations',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

export const syncCustomers = async (params = {}) => {
  return await SSharedList.getCustomers(params).then(
    ({ data }) => {
      setOfflineCustomers(data)
      return data
    }
  ).catch(() => {
    return []
  })
}

export const setOfflineCustomers = customers => {
  customers.forEach(customer => {
    fCustomers.setItem(String(customer.id), customer)
  })
}

export const getOfflineCustomers = async (filters = {}) => {
  const customers = []

  const hasProvince = nullOrUndefined(filters?.province_id)
  const hasMunicipality = nullOrUndefined(filters?.municipality_id)
  const hasStatus = nullOrUndefined(filters?.filter_status)
  const hasSearch = nullOrUndefined(filters?.filter_text)

  return await fCustomers.iterate(
    customer => {
      const provinceMatched = !hasProvince && Number(filters.province_id) >= 1 ? Number(customer.province_id) === Number(filters.province_id) : true
      const municipalityMatched = !hasMunicipality && Number(filters.municipality_id) >= 1 ? Number(customer.municipality_id) === Number(filters.municipality_id) : true
      const statusMatched = !hasStatus && String(filters.filter_status).toLowerCase() !== 'all' ? String(customer.status).toLowerCase() === String(filters.filter_status).toLowerCase() : true

      if (provinceMatched) {
        if (municipalityMatched) {
          if (statusMatched) {
            customers.push(customer)
          }
        }
      }
    }
  ).then(() => {
    const search = !hasSearch ? filters.filter_text : ''

    const filteredCustomers = fuseFilter(
      search,
      customers, {
        keys: ['first_name', 'last_name', 'middle_name', 'suffix_name', 'mobile_number', 'email', 'address']
      }
    )

    return {
      items: filteredCustomers.sort(
        (a, b) => {
          const aSort = a[filters?.sort || 'id'] || a?.created_at
          const bSort = b[filters?.sort || 'id'] || b?.created_at

          return String(filters?.sort_desc) === 'true' ? bSort - aSort : aSort - bSort
        }
      ).filter((_, rowIndex) => {
        const page = filters?.page || 1
        const perPage = filters?.per_page || 10
        return rowIndex >= (page - 1) * perPage && rowIndex < page * perPage
      }),
      total_rows: filteredCustomers.length
    }
  }).catch(() => {
    return []
  })
}
